<template>
  <div>
    <a-spin :spinning="loading">
      <div v-if="classSectionExamData">
        <!-- Exam Details -->
        <div class="row mb-2">
          <div class="col-12 col-md-6">
            <table class="table table-borderless table-sm mb-0">
              <tbody>
                <tr>
                  <th>Class</th>
                  <td>{{ classSectionExamData.school_class.name }}</td>
                </tr>
                <tr>
                  <th>Section</th>
                  <td>{{ classSectionExamData.section.name }}</td>
                </tr>
                <tr>
                  <th>Exam</th>
                  <td>{{ classSectionExamData.exam.name }}</td>
                </tr>
                <tr>
                  <th>Status</th>
                  <td>
                    <a-tag :color="classSectionExamData.declared ? 'green' : 'red'">{{ classSectionExamData.declared ? 'Declared' : 'Not declared' }}</a-tag>
                  </td>
                </tr>
                <tr>
                  <th>Grades</th>
                  <td>
                    <a-tag :color="classSectionExamData.grades ? 'green' : 'red'">{{ classSectionExamData.grades ? 'Enabled' : 'Disabled' }}</a-tag>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-6 col-md-4 text-right align-self-end">
            <a href="javascript:;" :class="[`${classSectionExamData.declared ? 'btn-primary' : 'btn-success'}`,'btn btn-sm btn-with-addon mr-2']"
              @click="handleDeclareExam('SINGLE')"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe', `${classSectionExamData.declared ? 'fe-stop-circle' : 'fe-play-circle'}`]" />
              </span>
              {{ classSectionExamData.declared ? 'Re-Declare (Single Section)': 'Declare (Single Section)'}}
            </a>
          </div>
          <div class="col-6 col-md-2 text-right align-self-end">
            <a href="javascript:;" :class="[`${classSectionExamData.declared ? 'btn-primary' : 'btn-success'}`,'btn btn-sm btn-with-addon mr-2']"
               @click="handleDeclareExam('ALL-SECTIONS')"
            >
              <span class="btn-addon">
                <i :class="['btn-addon-icon fe', `${classSectionExamData.declared ? 'fe-stop-circle' : 'fe-play-circle'}`]" />
              </span>
              {{ classSectionExamData.declared ? 'Re-Declare (All Sections)': 'Declare (All Sections)'}}
            </a>
          </div>
        </div>
        <div class="mt-3">
          <a-collapse v-model="activeKey" accordion>
            <a-collapse-panel header="Add Marks" key="1">
              <div class="row">
                <div class="col-12 col-md-8">
                  <p class="text-muted mb-0">Click on subject name to add marks</p>
                </div>
                <div class="col-12 col-md-2 mb-2 text-right">
                  <bulk-upload-student-mark :classSectionExamId="classSectionExamData.id" @created="handleSubjectMarkUpdate"/>
                </div>
                <div class="col-12 col-md-2 mb-2 text-right">
                  <bulk-upload-all-subject-marks :classSectionExamId="classSectionExamData.id" @created="handleSubjectMarkUpdate"/>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <vue-custom-scrollbar class="scroll-area">
                    <table class="table table-bordered w-100">
                    <thead>
                      <tr>
                        <th style="width: 5%">Roll</th>
                        <th style="width: 7%;">S. Code</th>
                        <th style="width: 20%;">Name</th>
                        <th
                          class="neo-exam-marks-subjects-cell"
                          v-for="examSubject in classSectionExamData.class_section_exam_subject"
                          :key="examSubject.id"
                          @click="openMarksFormModal(examSubject)"
                        >
                          {{ examSubject.subject.abbreviation }}
                        </th>
                        <th style="width: 5%; background: #f0f0f0">Total</th>
                        <th style="width: 5%; background: #f0f0f0">Sec Rank</th>
                        <th style="width: 5%; background: #f0f0f0">Class Rank</th>
                        <th style="width: 5%; background: #f0f0f0">Attendance</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="enrollment in classSectionExamData.students" :key="enrollment.id">
                        <th scope="row">{{ enrollment.roll_no }}</th>
                        <th scope="row">{{ enrollment.student_code }}</th>
                        <th scope="row" style="overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;">{{ enrollment.student.first_name }} {{ enrollment.student.last_name }}</th>
                        <td v-for="examSubject in classSectionExamData.class_section_exam_subject" :key="examSubject.id" class="px-2">
                          {{ getStudentSubjectMark(enrollment.student_exam_mark, examSubject) }}
                        </td>
                        <th scope="row" style="background: #f0f0f0">{{ enrollment.student_exam[0] ? enrollment.student_exam[0].total_mark : "--" }}</th>
                        <th scope="row" style="background: #f0f0f0">{{ enrollment.student_exam[0] ? enrollment.student_exam[0].section_rank : "--" }}</th>
                        <th scope="row" style="background: #f0f0f0">{{ enrollment.student_exam[0] ? enrollment.student_exam[0].class_rank : "--" }}</th>
                        <th scope="row" style="background: #f0f0f0">{{ enrollment.student_exam[0] ? enrollment.student_exam[0].attendance : "--" }}</th>
                      </tr>
                      <tr v-if="!classSectionExamData.students.length">
                        <td :colspan="classSectionExamData.class_section_exam_subject.length + 1">
                          <no-data text="No Students" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  </vue-custom-scrollbar>
                </div>
              </div>
            </a-collapse-panel>
            <a-collapse-panel header="Exam Report" key="2" :disabled="false">
              <display-student-exam-report :examData="classSectionExamData"/>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>
    </a-spin>

    <class-exam-marks-form @updated="handleSubjectMarkUpdate" />
  </div>
</template>

<script>
import moment from 'moment'
import { omit, find } from 'lodash'
import vueCustomScrollbar from 'vue-custom-scrollbar'

import ClassExamMarksForm from '@/components/exam/manage/Form/index'
import DisplayStudentExamReport from '@/components/exam/manage/Report/index'
import BulkUploadStudentMark from '@/components/exam/manage/Form/Bulk/index'
import BulkUploadAllSubjectMarks from '@/components/exam/manage/Form/BulkAllSubjects/index'

import NoData from '@/components/layout/NoData/index'

export default {
  name: 'DisplayClassSectionExam',
  components: {
    BulkUploadAllSubjectMarks,
    ClassExamMarksForm,
    DisplayStudentExamReport,
    NoData,
    BulkUploadStudentMark,
    vueCustomScrollbar,
  },
  mounted: function() {
    this.getClassExamData()
  },
  // props: ['classSectionExamData'],
  computed: {
    classSectionExamId: function () {
      return this.$route.params.id
    },
  },
  data: function() {
    return {
      loading: false,
      classSectionExamData: null,
      activeKey: ['1'],
    }
  },
  methods: {
    moment,
    handleSubjectMarkUpdate: function() {
      this.getClassExamData()
    },
    getClassExamData: function() {
      this.loading = true
      this.$http.get(`/api/classsectionexam/${this.classSectionExamId}`, {
        params: {
          with_students: 1,
          class_section_exam_id: this.classSectionExamId,
        },
      })
        .then(({ data }) => {
          this.classSectionExamData = data.data
          this.activeKey = data.data.declared ? ['2'] : ['1']
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },
    getStudentSubjectMark: function(studentExamMarks, examSubject) {
      const studentExamMark = find(studentExamMarks, { subject_id: examSubject.subject.id })
      let mark = ''
      if (studentExamMark) {
        if (examSubject.grades_only) {
          mark = studentExamMark.grade ? studentExamMark.grade : '--'
        } else {
          mark = (studentExamMark.mark || studentExamMark.mark === 0) ? studentExamMark.mark : '--'
        }
        /* if (studentExamMark.is_absent) {
          mark += '(AB)'
        } */
      } else {
        mark = '--'
      }

      return mark
    },
    openMarksFormModal: function(subject) {
      if (this.classSectionExamData.students.length) {
        const examData = omit(this.classSectionExamData, ['class_section_exam_subject'])
        this.loading = true
        this.$http.get(`/api/classsectionexam/${examData.id}`, {
          params: {
            with_students: 1,
            class_section_exam_id: examData.id,
            subject_id: subject.subject.id,
          },
        })
          .then(({ data }) => {
            this.loading = false
            this.$eventBus.$emit('openClassExamMarksForm', subject, examData, data.data.students)
          })
          .catch(error => {
            this.loading = false
            this.$neoNotify.error(error)
          })
      } else {
        this.$message.warning('No students found to add marks for!')
      }
    },
    handleDeclareExam(type) {
      console.log(type)
      this.$confirm({
        title: `Are you sure you want to declare the exam(s)?`,
        content: `Ranks and attendance are evaluated after exam is declared.Click on the OK button to declare the exam!`,
        onOk: () => {
          if (this.classSectionExamData.has_student_marks) {
            this.loading = true
            const formData = {
              class_section_exam_id: this.classSectionExamId,
              type: type,
            }
            this.$http
              .patch('/api/declareexam', formData)
              .then(() => {
                this.loading = false
                this.$notification['success']({
                  message: 'Successfully declared',
                  description: 'Exam has been declared successfully!',
                })
                this.getClassExamData()
              })
              .catch(error => {
                this.loading = false
                this.$neoNotify.error(error)
              })
          } else {
            this.$error({
              title: 'Cannot declare exam!',
              content: 'Marks not found for the exam!',
            })
          }
        },
        onCancel: () => {
          this.loading = false
        },
      })
    },
  },
}
</script>
